import { motion } from "motion/react";

import { ProductGrid } from "@/theme2/components/product/ProductGrid";
import CapsEmptyState from "@/theme2/components/caps/CapsEmptyState";

export default function CapsGrid({ products, view }) {
  if (!products.length) {
    return <CapsEmptyState />;
  }

  return (
    <motion.div
      key={view}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
      className={view === "compact" ? "text-[0.96em]" : ""}
    >
      <ProductGrid products={products} />
    </motion.div>
  );
}